import Home from './pages/Home.js'
import Prices from './pages/Prices.js';
import Header from './components/Header.js'
import Navigation from './components/Navigation.js'
import Footer from './components/Footer.js'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Introduction from './pages/Introduction.js';
import Shiatsu from './pages/Shiatsu.js';
import Chrono from './pages/Chrono.js';
import Bowen from './pages/Bowen.js';
import Indian from './pages/Indian.js';
import Metamorf from './pages/Metamorf.js';
import About from './pages/About.js';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <div className="d-flex main">
        <Navigation />
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/bemutatkozas' element={<Introduction/>}/>
          <Route path='/shiatsu-technika' element={<Shiatsu/>}/>
          <Route path='/kronobiologia' element={<Chrono/>}/>
          <Route path='/bowen-kezeles' element={<Bowen/>}/>
          <Route path='/indiai-fejmasszazs' element={<Indian/>}/>
          <Route path='/metamorf-erintes' element={<Metamorf/>}/>
          <Route path='/arlista' element={<Prices/>}/>
          <Route path='/elerhetosegek' element={<About/>}/>
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;